import script from "./MyAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyAccount.vue?vue&type=script&setup=true&lang=ts"

export default script